/**
 * Utilitaire pour extraire et formater les messages d'erreur de l'API
 */

export function getErrorMessage(error) {
  // Si c'est un objet Error avec status et data (depuis handleResponse)
  if (error?.data?.erreur) {
    return error.data.erreur;
  }

  if (error?.data?.detail) {
    return error.data.detail;
  }

  // Statuts HTTP spécifiques
  if (error?.status) {
    if (error.status === 401) {
      return 'Vous devez être connecté pour continuer.';
    }
    if (error.status === 403) {
      return 'Vous n\'avez pas la permission d\'accéder à cette ressource.';
    }
    if (error.status === 404) {
      return 'La ressource demandée n\'existe pas.';
    }
    if (error.status >= 500) {
      return 'Une erreur serveur est survenue. Veuillez réessayer plus tard.';
    }
  }

  // Si c'est un objet d'erreur avec message
  if (error?.message) {
    return error.message;
  }

  // Si c'est une string directe
  if (typeof error === 'string') {
    return error;
  }

  // Message par défaut
  return 'Une erreur est survenue. Veuillez réessayer.';
}

export function extractDetailedError(error) {
  const main = getErrorMessage(error);
  const detail = error?.data?.detail || error?.data?.errors || '';
  
  return {
    main,
    detail: detail ? String(detail) : '',
  };
}
